// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useLocation } from 'react-router-dom';

export function useQueryParams() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    return Object.fromEntries(query.entries());
}
